import * as React from 'react';
import { SVGProps } from 'react';

const SvgXlsx = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg width={25} height={32} viewBox="0 0 25 32" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
    <rect width={24} height={32} rx={3} fill="#D7E8E2" />
    <g clipPath="url(#xlsx_svg__a)">
      <rect x={5} y={17} width={20} height={10} rx={1} fill="#187254" />
      <path
        d="M6.189 25h1.433l1.384-2.224h.044L10.443 25h1.512l-2.053-3.169v-.017l2.079-3.155H10.5l-1.34 2.285H9.11l-1.349-2.285h-1.56l2.004 3.133v.013L6.189 25Zm6.508 0h4.1v-1.094h-2.773v-5.247h-1.327V25Zm7.203.11c1.6 0 2.558-.774 2.558-1.99v-.005c0-.998-.598-1.538-1.925-1.802l-.673-.136c-.73-.145-1.054-.378-1.054-.778v-.005c0-.452.408-.764 1.09-.768.654 0 1.111.303 1.177.8l.005.052h1.252l-.004-.084c-.062-1.111-.963-1.845-2.43-1.845-1.407 0-2.418.765-2.418 1.925v.004c0 .954.633 1.551 1.886 1.802l.668.132c.786.162 1.098.378 1.098.808v.005c0 .483-.461.804-1.195.804-.725 0-1.248-.308-1.331-.8l-.01-.048h-1.252l.005.07c.074 1.169 1.046 1.859 2.553 1.859Z"
        fill="#fff"
      />
    </g>
    <defs>
      <clipPath id="xlsx_svg__a">
        <rect x={5} y={17} width={20} height={10} rx={1} fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgXlsx;
